
import React from "react"
import './style.css'

function Loader({active}){
    return (
        <div 
            className={
                `loader -type-4
                ${active ? '-active': ''}
                `
            }>
                <div className="loader__ring -depth-1"></div>
                <div className="loader__ring -depth-2"></div>
                <div className="loader__ring -depth-3"></div>
        </div>
    )
}

export default Loader